










import { defineComponent } from "@vue/composition-api";
import Vue from "vue";
import { Transaction } from "@scrile/api-provider/dist/api/TransactionProvider";
import TransactionView from "../TransactionView.vue";

Vue.component("TransactionView", TransactionView);
export default defineComponent({
  name: "TransactionContentSet",
  components: { TransactionView },
  props: {
    transaction: { type: Object as () => Transaction, required: true },
  },
});
